import { Routes } from '@angular/router';
import { AuthGuardService } from './insti/auth-guard.service';


import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { ServicoConsumoFormComponent } from './gestao-condominio/servico-consumo/servico-consumo-form/servico-consumo-form.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: 'gestao-condominio/home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        redirectTo: '/dashboards/dashboard2',
        pathMatch: 'full'
      },
      {
        path: 'dashboards',
        loadChildren: './dashboards/dashboards.module#DashboardsModule',
        canActivate: [AuthGuardService]
      },
      {
        path: 'gestao-condominio',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-cadastros',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-modelos',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-itens-checklist',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-endereco',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-imoveis',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-pessoa',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-servicos',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
      {
        path: 'gestao-condominio-multiempresa',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule'
      },
     
      {
        path: 'forms',
        loadChildren: './forms/forms.module#FormModule'
      },
      {
        path: 'tables',
        loadChildren: './tables/tables.module#TablesModule'
      },
      {
        path: 'datatables',
        loadChildren: './datatables/datatables.module#DataTablesModule'
      },
      {
        path: 'pages',
        loadChildren: './pages/pages.module#PagesModule'
      },
      {
        path: 'widgets',
        loadChildren: './widgets/widgets.module#WidgetsModule'
      },
      {
        path: 'charts',
        loadChildren: './charts/chartslib.module#ChartslibModule'
      },
      {
        path: 'multi',
        loadChildren: './multi-dropdown/multi-dd.module#MultiModule'
      }
    ]
  },
  {
    path: '',
    component: AppBlankComponent,
    children: [
      {
        path: 'insti',
        loadChildren: './insti/insti.module#InstiModule'
      }
    ]
  },
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: 'instiUser',
        loadChildren: './insti/insti.module#InstiModule'
      }
    ]
  },

  {
    path: '',
    component: AppBlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: 'print',
    component: AppBlankComponent,
    children: [
      {
        path: '',
        loadChildren: './gestao-condominio/gestao-condominio.module#GestaoCondominioModule',
        canActivate: [AuthGuardService]
      }
    ]
  },

  {
    path: '**',
    redirectTo: 'authentication/404'
  }
];
